import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareChecklistBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareChecklistBell"><Path d="M7.54297 8.99775L8.66797 9.74775L10.5396 7.25224M13.558 8.5H16.558M7.54297 15.7489L8.66797 16.4989L10.5396 14.0034M20.5 11V3.5H3.5V20.5H11.5M16.7496 20.8291C17.0182 21.2337 17.478 21.5004 18 21.5004C18.5221 21.5004 18.9818 21.2337 19.2505 20.8291M21.5 20.5V17C21.5 15.067 19.933 13.5 18 13.5C16.067 13.5 14.5 15.067 14.5 17V20.5H21.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareChecklistBell;
